import { View, Text } from 'react-native'
import React from 'react'
import ScreenWrapper from '../../Components/ScreenWrapper'

const Search = () => {
  return (
    <ScreenWrapper>
      <Text>Search</Text>
    </ScreenWrapper>
  )
}

export default Search